<template>
  <div class="article-main">
    <!-- <div class="article-detail wap-topic-detail" v-if="isMobile && info.topic">
      <p class="detail">
        <i class="iconfont">&#xe636;</i>
        频道：<TopicTitle v-for="topic in info.topic" :id="topic.id" :title="topic.name" :key="topic.id" />
      </p>
    </div> -->
    <!-- 文章id为25111 的文章不显示头部信息 -->
    <template v-if="info.aid != 25111">
      <template v-if="isMobile">
        <h1>{{info.article_title | formatContent}}</h1>
        <div class="sub-title">{{info.article_subtitle}}</div>
      </template>
      <!-- PC端作者译者策划一排显示  这的译者跟策划只在PC显示 -->
      <div class="article-detail" v-if="isMobile">
        <template v-if="info.no_author">{{info.no_author}}</template>
        <ul class="author" v-else>
          <template v-if="info.author">
            <li v-for="author in info.author" :key="author.uid">
              <AuthorName :uid="author.uid" :name="author.nickname" />
            </li>
          </template>
          <template v-else>
            <li>佚名</li>
          </template>
        </ul>
        <template v-if="info.translator && !isMobile">
          <div class="divider"></div>
          <ul class="translate">
            <li v-for="translator in info.translator" :key="translator.uid">
              <AuthorName :uid="translator.uid" :name="translator.nickname" />
            </li>
          </ul>
        </template>
        <template v-if="info.planner && !isMobile">
          <div class="divider"></div>
          <ul class="planner">
            <li v-for="planner in info.planner" :key="planner.uid">
              <AuthorName :uid="planner.uid" :name="planner.nickname" />
            </li>
          </ul>
        </template>
      </div>
      <!-- 移动端译者 策划 都是单独一行显示 -->
      <div class="article-detail" v-if="info.translator && isMobile">
        <ul class="translate">
          <li v-for="translator in info.translator" :key="translator.uid">
            <AuthorName :uid="translator.uid" :name="translator.nickname" />
          </li>
        </ul>
      </div>
      <div class="article-detail" v-if="info.planner && isMobile">
        <ul class="planner">
          <li v-for="planner in info.planner" :key="planner.uid">
            <AuthorName :uid="planner.uid" :name="planner.nickname" />
          </li>
        </ul>
      </div>

      <div class="article-detail" v-if="isMobile">
        <p class="detail read-number">
          <!-- <i class="iconfont">&#xe671;</i> -->
          <span class="views">阅读数：{{info.views}}</span>
          <span class="date">{{info.publish_time | date('YYYY 年 M 月 D 日 hh:mm')}}</span>
        </p>
      </div>

      <div class="article-cover" v-if="isMobile">
        <img :src="info.article_cover" v-if="info.article_cover" :alt="info.article_title" />
      </div>
    </template>

    <RichContent class="article-content" :title="info.article_title" :content="info.content" />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import utils from '../../utils/'

import AuthorName from '../../components/title/AuthorName'
import TopicTitle from '../../components/title/TopicTitle'
import RichContent from './RichContent'

export default {
  name: 'article-content',
  components: {
    AuthorName,
    TopicTitle,
    RichContent
  },
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser'])
  },
  created () {
    utils.shareWeixin({
      title: this.info.article_title,
      desc: this.info.article_subtitle || this.info.article_summary,
      imgUrl: this.info.article_cover
    })
  },
  mounted () {
    this.initOpenInTab()
  },
  methods: {
    /**
     * 给所有 a 标签添加 target属性 外链 新标签页打开
     */
    initOpenInTab () {
      let tags = document.querySelector('.article-main').querySelectorAll('a')
      tags.forEach(item => {
        item.setAttribute('target', '_blank')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.article-main {
  width: 100%;

  & h1 {
    line-height: 36px;
    color: $black;
    @include font(28, 500);
  }

  & .sub-title {
    padding: 9px 0 18px;
    line-height: 24px;
    @include font(18, 400);
  }
}

.article-detail {
  display: flex;
  justify-content: flex-start;
  padding-top: 10px;
  @include lineFont(14, 400);
  color: $gray;

  & .author,
  & .translate,
  & .planner {
    display: flex;
    flex-wrap: wrap;
    
    & li {
      margin-right: 4px;
      color: $black;

      &:before {
        content: ', '
      }

      &:first-child:before {
        content: ' ';
      }
    }
  }

  & .author:before {
    content: '作者：';
  }
  & .translate:before {
    content: '译者：';
  }
  & .planner:before {
    content: '策划：';
  }

  & .divider {
    &:before {
      content: ' ';
      display: block;
      position: relative;
      margin: 0 15px 0 7px;
      top: 2px;
      width: 1px;
      height: 8px;
      background: $gray;
    }
  }

  & .detail {
    position: relative;
    display: flex;

    & .iconfont {
      position: absolute; left: -18px; top: -1px;
      @include lineFont(14, 400);
    }

    &.read-number {
      margin-right: 15px;
    }

    &.topic {
      position: relative;
      // padding-left: 15px;

      // &:before {
      //   content: ' ';
      //   display: block;
      //   position: absolute;
      //   left: 0px;
      //   top: 2px;
      //   width: 1px;
      //   height: 8px;
      //   background: $gray;
      // }
    }

    & .com-topic-title {
      margin-right: 16px;
      @extend %animateFontHover;
      color: $gray;

      &:last-child {
        margin-right: 0;
      }
    }

  }

  & .views {
    position: relative;
    padding-right: 31px;

    &:before {
      content: ' ';
      display: block;
      position: absolute; right: 15px; top: 2px;
      width: 1px; height: 8px;
      background: $gray;
    }
  }
}

.article-cover {
  width: 100%;
  padding: 20px 0 40px;

  & img {
    display: none;
    width: 100%;
    border-radius: 3px;
  }
}

@media screen and (max-width: 768px) {
  .article-main {
    display: flex;
    flex-direction: column;

    & h1 {
      padding-top: 7px;
      margin-bottom: 10px;
      font-weight: 500;
      text-align: justify;
    }

    & .sub-title {
      padding: 0px;
      line-height: 27px;
      color: $lightBlack;
    }
  }

  .article-cover {
    order: -1;
    width: auto;
    padding: 0; margin: 0 -20px;

    & img {
      border-radius: 0;
    }
  }

  .article-detail {
    padding-top: 0px;
    line-height: 23px;

    & .author li,
    & .translate,
    & .planner li {
      font-weight: 400;
    }

    & .divider {
      &:before {
        top: 6px;
      }
    }

    & .views:before {
      top: 7px;
    }
  }

  .wap-topic-detail {
    padding-top: 14px;
    line-height: 12px;
    
    & .detail {
      flex-wrap: wrap;
      padding-left: 14px;

      & .iconfont {
        left: -2px;
        @include font(12, 400);
      }
    }
  }

  .article-content {
    padding-top: 30px;
  }
}
</style>

 